<template>
  <v-row
    class="base-layout no-gutters"
  >
    <StHeader
      @side-icon-clicked="toggleDrawer"
    >
      <template #center>
        <StCompanySelector
          class="mx-6"
          :companies="companies"
          :company-id="companyId"
          @updateCompany="updateCompany"
        />
      </template>

      <template #right>
        <div class="base-layout__right">
          <StUserMenu
            :user="user"
            :greeting="$t('Layout.greeting')"
            :logout-label="$t('Layout.logout')"
            @logout-item-clicked="logoutAndSendUserToLoginPage"
          />
        </div>
      </template>
    </StHeader>

    <v-main
      class="content-white"
    >
      <v-row class="no-gutters fill-height">
        <LayoutContent />

        <StSystemNavigationDrawer
          :drawer="drawer"
          :items="itemsInDrawer"
          :active-url="itemActive"
        />
      </v-row>
    </v-main>
  </v-row>
</template>

<script>
import StHeader from '@stilingue/st-header';
import StUserMenu from '@stilingue/st-user-menu';
import StCompanySelector from '@stilingue/st-company-selector';
import StSystemNavigationDrawer from '@stilingue/st-system-navigation-drawer';
import LayoutContent from '@/components/LayoutContent';
import { insertPluginMetadata } from '@/plugins/insert_plugins_metadata';
import { logoutAndSendUserToLoginPage } from '@stilingue/st-auth-utils';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'Layout',
  components: {
    StSystemNavigationDrawer,
    StHeader,
    StCompanySelector,
    StUserMenu,
    LayoutContent
  },
  data() {
    return {
      itemActive: 'https://tickets.stilingue.com.br',
      itemsInDrawer: [
        {
          name: this.$t('StSystemNavigationDrawer.tickets'),
          link: 'https://tickets.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.permissions'),
          link: 'https://permissoes.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.warroom'),
          link: 'https://warroom.stilingue.com.br'
        },
        {
          name: this.$t('StSystemNavigationDrawer.sac'),
          link: 'https://warroom.stilingue.com.br/conversas'
        },
        {
          name: this.$t('StSystemNavigationDrawer.performance'),
          link: 'https://warroom.stilingue.com.br/metricas-proprietarias'
        }
      ]
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('misc', ['drawer']),
    ...mapState('company', ['companies', 'activeCompany']),
    companyId() {
      return String(this.activeCompany.id);
    }
  },
  async created() {
    insertPluginMetadata({
      user: this.user,
      activeCompany: this.activeCompany
    });
  },
  methods: {
    logoutAndSendUserToLoginPage,
    ...mapMutations('misc', {
      toggleDrawer: 'TOGGLE_DRAWER'
    }),
    ...mapMutations('company', {
      mutateCompany: 'MUTATE'
    }),
    updateCompany(company) {
      this.mutateCompany({
        property: 'activeCompany',
        with: company
      });
    }
  }
};
</script>

<style scoped lang="scss">
.base-layout {
  background: white;

  &__right {
    transform: translateX(-15px);
  }
}

::v-deep {
  .home-sidebar-inbox,
  .home-sidebar-inbox--dark {
    background-color: #363636 !important;
    visibility: visible;
    transform: translateX(0%) !important;
  }

  .navbar-collapse-btn {
    position: fixed;
    left: 0%;
    bottom: 5%;
    align-self: center;
  }
}
</style>
